"use client";
import { Api } from "@/Apis";
import { ApiResult } from "@/Apis/ClinicApi";
import { If } from "@/Components";
import { ChildrenOf } from "@/Helpers/CenterOptions.types";
import { formProps } from "@/Helpers/Constants";
import { useApp, useT } from "@/Hooks";
import useConstants from "@/Hooks/useConstants";
import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  Input,
  Rate,
  Row,
  Spin,
} from "antd";
import { FC, useState } from "react";

export interface LandingCommentCreateOrEditPageForm {
  UniqueCode: number;
  TypeKey: ChildrenOf<"CommentType">;
  CenterUserDoctorId?: number;
  BlogId?: number;
  CenterId?: number;
  CenterItemId?: number;

  ParentId?: number;
  Text: string;
  Score?: number;
}

export interface LandingCommentCreateOrEditPageProps {
  values: Partial<LandingCommentCreateOrEditPageForm>;
  callback: (result: boolean) => void;
  showCancelButton?: boolean;
  title?: string;
}

const LandingCommentCreateOrEditPage: FC<
  LandingCommentCreateOrEditPageProps
> = ({ values, callback, showCancelButton, title }) => {
  const { cancelButtonProps, saveButtonProps } = useConstants();
  const t = useT();
  const [form] = Form.useForm<LandingCommentCreateOrEditPageForm>();
  const [loading, setLoading] = useState(false);
  const { message } = useApp();
  const onFinish = async (values: LandingCommentCreateOrEditPageForm) => {
    setLoading(true);
    try {
      let r: ApiResult;
      // if (id)
      //     r = await Api.LandingComment.edit(values);
      // else
      r = await Api.LandingComment.create(values);
      if (r.Success) {
        message.success(
          t(
            "landing.comment.createOrEdit.commentSubmittedPendingApproval",
            undefined,
            "Comment",
          ),
        );
        form.resetFields();
        form.setFieldValue("UniqueCode", new Date().getTime());
        callback(true);
      } else message.errors(r.Errors);
    } catch (error) { }
    setLoading(false);
  };
  // useEffect(() => {
  //     const load = async () => {
  //         if (id) {
  //             setLoading(true);
  //             try {
  //                 let { Result } = await Api.LandingComment.find({ Id: id, Role: role });
  //                 if (Result) form.setFieldsValue(Result);
  //             } catch (error) { }
  //         }
  //         setLoading(false);
  //     }
  //     load()
  // }, [id]);

  return (
    <Spin spinning={loading}>
      <Card
        title={
          title ??
          t("landing.comment.createOrEdit.submitComment", undefined, "Comment")
        }
      >
        <Form
          {...formProps}
          initialValues={{
            ...values,
            UniqueCode: new Date().getTime(),
          }}
          onFinish={onFinish}
          form={form}
        >
          <Form.Item hidden name="UniqueCode">
            <Input />
          </Form.Item>
          <Form.Item hidden name="ParentId">
            <Input />
          </Form.Item>
          <Form.Item hidden name="TypeKey">
            <Input />
          </Form.Item>
          <Form.Item hidden name="CenterUserDoctorId">
            <Input />
          </Form.Item>
          <Form.Item hidden name="BlogId">
            <Input />
          </Form.Item>
          <Form.Item hidden name="CenterId">
            <Input />
          </Form.Item>
          <Form.Item hidden name="CenterItemId">
            <Input />
          </Form.Item>
          <Row>
            <If condition={!values.ParentId}>
              <Col md={12} xs={24}>
                <Form.Item
                  name="Score"
                  label={t("common.field.score", undefined, "Comment")}
                  rules={[{ required: true }]}
                >
                  <Rate />
                </Form.Item>
              </Col>
            </If>
            <Col span={24}>
              <Form.Item
                name="Text"
                label={t(
                  "landing.comment.createOrEdit.commentText",
                  undefined,
                  "Comment",
                )}
                rules={[{ required: true }]}
              >
                <Input.TextArea
                  autoSize={{ minRows: 4 }}
                  maxLength={500}
                  showCount
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Flex justify="end" gap={8}>
                <If condition={!!showCancelButton}>
                  <Button
                    {...cancelButtonProps}
                    onClick={() => callback(false)}
                  />
                </If>
                <Button {...saveButtonProps}>
                  {t("common.action.send", undefined, "Comment")}
                </Button>
              </Flex>
            </Col>
          </Row>
        </Form>
      </Card>
    </Spin>
  );
};

export default LandingCommentCreateOrEditPage;
